import React from "react";
import { FaRegEdit, FaTrashAlt } from "react-icons/fa";
import styles from "../styles/modules/AdminPage.module.css";

interface ActionIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: "edit" | "delete";
}

const ActionIconButton: React.FC<ActionIconButtonProps> = ({
  variant,
  type = "button",
  title,
  ...buttonProps
}) => {
  return (
    <button
      className={styles.iconbutton}
      type={type}
      data-variant={variant}
      title={title ?? (variant === "edit" ? "編集" : "削除")}
      {...buttonProps}
    >
      {variant === "edit" ? <FaRegEdit size={15} /> : <FaTrashAlt size={15} />}
    </button>
  );
};

export default ActionIconButton;
